import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import IntroScreen from "./components/lootbox/IntroScreen";
import LootboxSelection from "./components/lootbox/LootboxSelection";
import { usePlay } from "./hooks/usePlay";
import { useNeuralToast } from "./components/ui/NeuralToast.tsx";
import ConnectWalletButton from "./components/ui/ConnectWalletButton";

function App() {
  const [stage, setStage] = useState<1 | 2>(1);
  const [userId, setUserId] = useState<string | null>(null);
  const { Toast } = useNeuralToast();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const user = params.get("user");
    if (user) setUserId(user);
  }, []);

  const {
    balance,
    loading,
    refreshBalance,
    tokenBalances,
    startBoxOpening,
    openingResult,
  } = usePlay(userId);

  useEffect(() => {
    console.log({ balance, openingResult, loading });
  }, [balance, openingResult, loading]);

  const onContinue = (stage: 1 | 2) => {
    console.log(`Continue to stage ${stage}`);
    setStage(stage);
  };

  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);
    return () => document.removeEventListener("contextmenu", handleContextMenu);
  }, []);

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      // (optional) restrict to known origin
      // if (!event.origin.includes("gamblor.io")) return;

      const { type } = event.data || {};

      switch (type) {
        case "DEPOSIT_UPDATE":
          console.log("💰 DEPOSIT_UPDATE received, calling refreshBalance...");
          refreshBalance();
          console.log("💰 refreshBalance() called");
          break;

        case "SESSION_END":
          console.log("🧠 Session ended by main site");
          window.location.reload();
          break;

        default:
          break;
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [refreshBalance]);

  return (
    <div className="relative w-full h-screen md:overflow-hidden bg-gradient-to-b from-[#05070c] to-[#0a0e17]">
      <div className="absolute top-4 right-4 z-50">
        <ConnectWalletButton />
      </div>

      <AnimatePresence mode="wait">
        {stage === 1 && (
          <IntroScreen key="intro" onContinue={() => onContinue(2)} />
        )}
        {stage === 2 && (
          <LootboxSelection
            key="selection"
            context={{
              userId,
              balance,
              tokenBalances,
              startBoxOpening,
              openingResult,
            }}
          />
        )}
        <Toast />
      </AnimatePresence>
    </div>
  );
}

export default App;
